import Box from '@mui/material/Box';

export default function Logo() {
  return (
    <Box component='svg' aria-labelledby='logo' width='58px' height='58px' viewBox='0 0 58 61' version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <title>logo</title>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='assets' transform='translate(-432.000000, -742.000000)'>
          <g id='Group-24' transform='translate(211.000000, 160.000000)'>
            <g id='logo' transform='translate(221.000000, 582.000000)'>
              <g id='Group-23' fill='#000000'>
                <circle cx='13' cy='13' r='13'></circle>
                <circle cx='45' cy='13' r='13'></circle>
                <circle cx='13' cy='45' r='13'></circle>
                <circle cx='45' cy='45' r='13'></circle>
              </g>
              <g id='Group-23-Copy' transform='translate(0.000000, 3.000000)' fill='#000000'>
                <circle cx='13' cy='13' r='13'></circle>
                <circle cx='45' cy='13' r='13'></circle>
                <circle cx='13' cy='45' r='13'></circle>
                <circle cx='45' cy='45' r='13'></circle>
              </g>
              <circle fill='#FD6687' cx='13' cy='13' r='10'></circle>
              <circle fill='#FD6687' cx='45' cy='45' r='10'></circle>
              <circle fill='#FFCE67' cx='45' cy='13' r='10'></circle>
              <circle fill='#FFCE67' cx='13' cy='45' r='10'></circle>
            </g>
          </g>
        </g>
      </g>
    </Box>
  );
}
